export default __webpack_public_path__ + "static/media/bunny-shadow.1a9507c2.png";